export default function timeFormat(time: number) {
  const safe = Math.max(0, Math.floor(time));
  let seconds = (safe % 60) + '';
  if (seconds.length < 2) seconds = '0' + seconds;
  return Math.floor(safe / 60) + ':' + seconds;
}